<script>
    import Section from "./Section.svelte";
    import {sections} from './content'
</script>

<div class="content">
    <div class="tool-menu">
        {#each sections as section (section.title)}
            <Section section={section}/>
        {/each}
    </div>
</div>

<style>

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .tool-menu {
        background: var(--theme-colors-background-content);
        border: solid var(--theme-colors-border) 1px;
        border-radius: 15px;
        padding: 1em;
        margin: 1em;
        min-width: 50vw;
        max-width: min(1000px, calc(100vw - 4em));
    }

</style>